const routes = [
  {
    path: '/pages/shop/shop',
    name: 'shop',
    meta: {
      title: "商城",
      keepAlive: true
    },
    component: () => import('../pages/shop/shop.vue')
  },
  {
    path: '/pages/shop/shopHome/gameGoods',
    name: 'gameGoods',
    meta: {
      title: "游戏商品"
    },
    component: () => import('../pages/shop/gameGoods.vue')
  },
  {
    path: '/pages/shop/goodsDetail',
    name: 'goodsDetail',
    meta: {
      title: "商品详情"
    },
    component: () => import('../pages/shop/goodsDetail.vue')
  },
  {
    path: '/pages/shop/search',
    name: 'searchGgoods',
    meta: {
      title: "搜索商品"
    },
    component: () => import('../pages/shop/searchGoods.vue')
  },
  {
    path: '/pages/shop/order/makeOrder',
    name: 'makeOrder',
    meta: {
      title: "商品下单"
    },
    component: () => import('../pages/shop/order/makeOrder.vue')
  },
  {
    path: '/pages/shop/pay/pay',
    name: 'pay',
    meta: {
      title: "商品支付"
    },
    component: () => import('../pages/shop/pay/pay.vue')
  },
  {
    path: '/pages/shop/pay/result',
    name: 'payresult',
    meta: {
      title: "支付成功"
    },
    component: () => import('../pages/shop/pay/result.vue')
  },
  {
    path: '/pages/shop/order/address',
    name: 'address',
    meta: {
      title: "选择地址"
    },
    component: () => import('../pages/shop/order/address.vue')
  },
  {
    path: '/pages/shop/order/addAddress',
    name: 'addAddress',
    meta: {
      title: "新增地址"
    },
    component: () => import('../pages/shop/order/addAddress.vue')
  },
  {
    path: '/pages/shop/pay/payIframe',
    name: 'payIframe',
    meta: {
      title: "付款页"
    },
    component: () => import('../pages/shop/pay/payIframe.vue')
  }
]

export default routes